import {useEffect, useState} from 'react';

const ROTATE_MS = 4500;

function getRotatingMessageIndex(tick: number, count: number, loopFrom: number) {
  if (tick < count) return tick;
  const loopLength = count - loopFrom;
  if (loopLength <= 0) return count - 1;
  return loopFrom + ((tick - loopFrom) % loopLength);
}

type Options = {
  loopFrom?: number;
  intervalMs?: number;
  paused?: boolean;
  resetKey?: unknown;
};

function useRotatingMessage(
  messages: string[],
  {loopFrom = 0, intervalMs = ROTATE_MS, paused = false, resetKey}: Options = {},
) {
  const [tick, setTick] = useState(0);

  useEffect(() => {
    setTick(0);
  }, [resetKey]);

  useEffect(() => {
    if (paused) return;
    const interval = setInterval(() => setTick(prev => prev + 1), intervalMs);
    return () => clearInterval(interval);
  }, [intervalMs, paused]);

  const index = getRotatingMessageIndex(tick, messages.length, loopFrom);
  return {message: messages[index], index};
}

export {getRotatingMessageIndex, useRotatingMessage};
